// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__2j1qM","warning":"Alert_warning__3H2g8","icon":"Alert_icon__2JAk6"};